import React, { Fragment } from 'react';
import { FiMinus, FiPlus } from 'react-icons/fi';
import useShopDetail from '../../Hooks/Shop/useShopDetail';


const ShopDetail = () => {

    const [
        products,
        selectedVariation,
        color,
        itemQuantity,
        handleColor,
        handleSize,
        handleWeight,
        handleIncreament,
        handleDecreament,
        handleAddToCart
    ] = useShopDetail();

    return (
        <Fragment>


            {products && (
                <>
                    <div className="container px-5 my-5 shop-detail">
                        <div className="row align-items-center justify-content-around">
                            <div className="col-12 col-lg-auto" >
                                <div className="card W-100 book-detail-card overflow-hidden bg-light d-flex justify-content-center border-0 align-items-center" >
                                    <img src={products?.image_url} width={"100%"} height={"100%"} style={{ objectFit: "cover" }} alt="" />
                                </div>

                            </div>

                            <div className="col-lg-6">
                                <h2 className='s-30 fw-600 mb-3'>
                                    {products?.title}
                                </h2>

                                <p className='fw-300'>
                                    {products?.description}
                                </p>

                                <div className="row justify-content-start my-4">
                                    <div className="col-auto">
                                        <h4 className='s-21   fw-600 mb-0 '>Price {" "} <span className='s-16 fw-400'> $   {selectedVariation?.type ? selectedVariation?.price : products?.latest_price}  </span></h4>
                                    </div>
                                </div>

                                <hr />

                                <div className="row justify-content-start my-4">
                                    <div className="col-auto">
                                        <div className="row">
                                            <div className="col-auto">
                                                <h4 className='s-21   fw-600 mb-0 '>Colors: {" "} </h4>
                                            </div>

                                            {products?.choice_options?.map((choice, i) => {
                                                return choice?.type === "colour" || choice?.type === "Colour" ? (
                                                    choice?.options.map((bg, i) => (
                                                        <div className="col-auto ps-0" key={i} >
                                                            <div className="row g-2">
                                                                <div className="col-auto ps-0">
                                                                    <div onClick={() => { handleColor(bg) }} className={`${color === bg ? "border-dark border border-2" : ""} shadow-sm rounded-2`} style={{ background: bg, width: "25.87px", height: "26.33px" }}></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : null;
                                            })}

                                            {products?.choice_options?.map((choice, i) => {
                                                if (choice?.type === "size" || choice?.type === "Size") {
                                                    return (
                                                        <div className="col-auto" key={i}>
                                                            <h4 className="s-21 fw-600 mb-0">
                                                                Size {" "}
                                                                <span className="s-16 fw-400">
                                                                    <select name="size" id="size" onChange={(e) => { handleSize(e.target.value) }} className="border-0 text-muted">
                                                                        <option value="" disabled>Select Size</option>
                                                                        {choice?.options.map((size, index) => (
                                                                            <option key={index} value={size}>
                                                                                {size}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </span>
                                                            </h4>
                                                        </div>
                                                    );
                                                }
                                                else if (choice?.type === "weight" || choice?.type === "Weight") {
                                                    return (
                                                        <div className="col-auto mt-3 mt-lg-0" key={i}>
                                                            <h4 className="s-21 fw-600 mb-0">
                                                                Weight {" "}
                                                                <span className="s-16 fw-400">
                                                                    <select name="weight" id="weight" onChange={(e) => { handleWeight(e.target.value) }} className="border-0 text-muted">
                                                                        <option value="" disabled>Select Weight</option>
                                                                        {choice?.options.map((weight, index) => (
                                                                            
                                                                            <option key={index} value={weight}>
                                                                                {weight}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </span>
                                                            </h4>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })}





                                        </div>

                                    </div>


                                </div>


                                {selectedVariation?.qty != 0 && (
                                    <>
                                        <div className="row justify-content-center align-items-center ">
                                            <div className="col-auto">
                                                <div className="card bg-danger mb-3 mb-lg-0 border-0 quantity-card px-3 justify-content-center">
                                                    <div className="row justify-content-center align-items-center">
                                                        <div className="col-auto">
                                                            <p className='text-white mb-0 s-18'>
                                                                Qty
                                                            </p>
                                                        </div>
                                                        <div className="col-auto">
                                                            <div className="row g-2">
                                                                <div className="col-auto">
                                                                    <button onClick={handleIncreament} className='btn-sm btn btn-dark p-0 btn-quantity' >
                                                                        <FiPlus size={24} />
                                                                    </button>
                                                                </div>
                                                                <div className="col-auto">
                                                                    <div className='rounded btn-count text-danger '>{itemQuantity}</div>
                                                                </div>
                                                                <div className="col-auto">

                                                                    <button onClick={handleDecreament} className='btn-sm btn btn-dark p-0 btn-quantity '><FiMinus size={24} /></button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-auto ps-0">


                                                < button onClick={handleAddToCart} className='px-5  btn btn-dark add-to-card-btn'>
                                                    Add To Cart
                                                </button>
                                            </div>

                                            <div className="col ps-0">
                                                <p className='text-danger s-14 mb-0'>
                                                    {selectedVariation?.type ? selectedVariation?.qty : products?.stock} Products Remaining</p>
                                            </div>
                                        </div>
                                    </>
                                )}



                            </div>
                        </div>
                    </div>

                    <div className="bg-light my-5">
                        <div className="container px-4">
                            <div className="row justify-content-around">
                                <div className="col-11 py-100">
                                    <h3 className='text-danger s-30 fw-600 mb-3'>Author: <span className='text-dark s-30 fw-600'>By Rennwrites</span></h3>

                                    <p className='fw-400'>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus tempor ipsum in metus scelerisque rhoncus
                                        in vitae justo. Fusce commodo dui ac sollicitudin rhoncus. Phasellus non viverra eros. Nam efficitur,
                                        augue in feugiat hendrerit, nisl lectus finibus ex, eu vestibulum metus augue ut nibh. Praesent eget mauris
                                        non nulla luctus accumsan. Sed aliquam metus odio. Nunc quam urna, imperdiet tincidunt porttitor quis,
                                        consequat tempor nibh. Nulla facilisi. Nullam finibus interdum diam, at ultrices nisl rutrum sit amet.
                                        Fusce et lacus quis nulla gravida sodales vitae eget diam. Etiam convallis elit porttitor tellus porta
                                        porttitor. Etiam diam eros, cursus eget semper non, accumsan facilisis risus. Donec placerat maximus maximus.
                                        Sed a nulla non felis ultricies pharetra eget nec purus. Cras tortor justo, ullamcorper posuere feugiat non,
                                        finibus vel neque. Vestibulum placerat vestibulum ligula in lacinia. Nulla sit amet justo augue. Praesent
                                        bibendum urna eros, vitae convallis odio porttitor in. Curabitur ac porta eros. Phasellus odio tortor,
                                        eleifend vitae volutpat non, molestie vitae purus. Proin non congue ligula, ut dapibus leo. Nunc pulvinar
                                        mattis enim, quis ultrices mauris tempor non. In vitae sodales turpis. Mauris ultricies cursus mattis.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
            }

        </Fragment >
    )
}

export default ShopDetail